import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api/admin`;

// Token is stored in memory + localStorage as fallback (cookie is httpOnly and
// primary — this Bearer copy is a safety net for browsers that block 3rd-party
// cookies on the preview subdomain).
const TOKEN_KEY = "oasys_admin_token";

export const adminApi = axios.create({
  baseURL: API,
  withCredentials: true,
});

adminApi.interceptors.request.use((config) => {
  const token = localStorage.getItem(TOKEN_KEY);
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const adminAuth = {
  async login(email, password) {
    const { data } = await adminApi.post("/auth/login", { email, password });
    if (data?.token) localStorage.setItem(TOKEN_KEY, data.token);
    return data;
  },
  async me() {
    const { data } = await adminApi.get("/auth/me");
    return data;
  },
  async logout() {
    try {
      await adminApi.post("/auth/logout");
    } finally {
      localStorage.removeItem(TOKEN_KEY);
    }
  },
};

export const macdLeads = {
  metrics: (params) =>
    adminApi.get("/macd-connect/metrics", { params }).then((r) => r.data),
  list: (params) =>
    adminApi.get("/macd-connect/leads", { params }).then((r) => r.data),
  update: (id, patch) =>
    adminApi.patch(`/macd-connect/leads/${id}`, patch).then((r) => r.data),
  async downloadExport(kind, params) {
    const resp = await adminApi.get(`/macd-connect/export.${kind}`, {
      params,
      responseType: "blob",
    });
    const blob = new Blob([resp.data], {
      type: resp.headers["content-type"] || "application/octet-stream",
    });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    const cd = resp.headers["content-disposition"] || "";
    const m = cd.match(/filename="?([^"]+)"?/);
    a.href = url;
    a.download = m ? m[1] : `macd-connect.${kind}`;
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(url);
  },
};

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Algo deu errado. Tente novamente.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
